module.exports = __webpack_public_path__ + "static/media/invites_paper.2f77664b.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/doodles/invites_paper.svg
 ** module id = 1970
 ** module chunks = 50
 **/